import { type CSSProperties } from "react";

import { CtaLink } from "@/components/public/CtaLink";
import { PUBLIC_LINK } from "@/components/public/control-classes";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

/** Authored public preview: real controls with public identity, no submission writer. */
export function PublicControlSpecimen({ idPrefix }: { idPrefix: string }) {
  const emailId = `${idPrefix}-public-email`;
  const noteId = `${idPrefix}-public-note`;
  return (
    <section
      data-public-control-specimen
      aria-labelledby={`${idPrefix}-public-controls`}
      className="grid gap-4 rounded-xl border border-[var(--public-rule)] bg-[var(--public-background)] p-5 text-[var(--public-foreground)]"
      style={{ "--card": "var(--auth-field)", "--input": "var(--auth-border)" } as CSSProperties}
    >
      <div>
        <p className="eyebrow">Public and member access</p>
        <h2 id={`${idPrefix}-public-controls`} className="font-display text-title">Identity pages, shared controls</h2>
        <p className="mt-2 text-ui text-[var(--public-foreground-soft)]">Public palette and scholarly headings stay with the institution. Fields, actions, and recovery links use the shared pointer density and visible keyboard focus.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2" id={`${idPrefix}-public-fields`}>
        <div className="grid gap-2"><Label htmlFor={emailId}>Public email preview</Label><Input id={emailId} type="email" autoComplete="email" placeholder="Your email address" /></div>
        <div className="grid gap-2"><Label htmlFor={noteId}>Public inquiry preview</Label><Textarea id={noteId} placeholder="Questions for the academic office" /></div>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <CtaLink to={`#${idPrefix}-public-fields`}>Review public fields</CtaLink>
        <CtaLink to="/sign-in" variant="ghost">Member sign in</CtaLink>
        <Button disabled variant="outline">Invitation required</Button>
      </div>
      <a href="/forgot-password?method=recovery-code" className={`${PUBLIC_LINK} justify-self-start text-ui text-[var(--public-primary)] hover:underline`}>Enter a recovery code</a>
    </section>
  );
}
